import React, {useCallback, useMemo, useState} from 'react'
import DropDownBox from 'devextreme-react/drop-down-box'
import {Popup} from 'devextreme-react/popup'
import {Button} from 'devextreme-react/button'
import {PopupTitleWithIcon} from '../popup-title-with-icon/popup-title-with-icon'
import SignPointsTree, {DOG_PROFILE_ID, DOG_PROFILE_TITLE} from './sign-points-tree'
import '../points-tree/points-tree.scss'

/**
 * Узкий экран: DropDownBox → Popup с деревом ± (как PopupPointsTreeHook в истории показаний).
 */
export default function PopupSignPointsTree({
    points = [],
    technicalPoints = [],
    selected = [],
    onChange,
    onShow,
    showDisabled = false,
    dogProfile = false,
    onDogProfileChange,
}) {
    const [popupVisible, setPopupVisible] = useState(false)

    const hidePopup = useCallback(() => setPopupVisible(false), [])

    const handleShow = useCallback(() => {
        setPopupVisible(false)
        if (onShow) onShow()
    }, [onShow])

    const dataSource = useMemo(() => {
        const items = []
        if (dogProfile) items.push({id: DOG_PROFILE_ID, t: DOG_PROFILE_TITLE})
        for (const s of selected) {
            items.push({
                id: s.id,
                t: `${s.sign === -1 ? '−' : '+'} ${s.t}`,
            })
        }
        return items
    }, [selected, dogProfile])
    const value = useMemo(() => dataSource.map((s) => s.id), [dataSource])

    return (
        <div>
            <DropDownBox
                id="ddb-sign-points"
                value={value}
                valueExpr="id"
                displayExpr="t"
                placeholder="Выберите точки учёта"
                showClearButton={false}
                dataSource={dataSource}
                disabled={false}
                deferRendering={false}
                opened={false}
                onOptionChanged={(e) => {
                    if (e.name === 'opened' && e.value === true) {
                        e.component.option('opened', false)
                        setPopupVisible(true)
                    }
                }}
            />
            <Popup
                visible={popupVisible}
                dragEnabled={true}
                hideOnOutsideClick={true}
                showCloseButton={true}
                showTitle={true}
                onHiding={hidePopup}
                maxWidth="800px"
                width="95%"
                maxHeight="95%"
                height="95%"
                wrapperAttr={{class: 'popup-points-tree-wrapper'}}
                titleRender={() => PopupTitleWithIcon('dx-icon-hierarchy', 'Выберите', hidePopup)}
            >
                <div className="popup-points-tree">
                    <div className="popup-points-tree__list">
                        <SignPointsTree
                            points={points}
                            technicalPoints={technicalPoints}
                            value={selected}
                            onChange={onChange}
                            dogProfile={dogProfile}
                            onDogProfileChange={onDogProfileChange}
                        />
                    </div>
                    <div className="popup-points-tree__footer">
                        <Button
                            type="default"
                            text="Показать"
                            icon="refresh"
                            disabled={showDisabled || (!selected.length && !dogProfile)}
                            onClick={handleShow}
                        />
                    </div>
                </div>
            </Popup>
        </div>
    )
}
